// To see hub go to http://localhost:4446/signalr/hubs

function createConnection(hubReference, hubProxy, group="GroupX") {
  // console.log("🚀 ~ createConnection ~ hubReference, hubProxy, group:", hubReference, hubProxy, group)
  try {

  
/*   var connection = $.hubConnection(`${hubReference}`, {
    useDefaultPath: false,
  }); */

  var connection = new signalR.HubConnectionBuilder()
  .withUrl(`${hubReference}/${hubProxy}`)
  .build();

  connection.start().then(() => 
    {
      connection.invoke("JoinGroup", group).catch(err => console.error(err.toString()));
      console.log("Now connected to " + hubProxy+ ", connection ID=" + connection.id);

    }).catch(err => console.error('Connection failed: ', err.toString()));

  return { connection };
  } catch(err) {
    console.error(err);
    return {}
  }
}

export { createConnection };
